import React, { useEffect, useState, useRef } from "react";
import "./Gallery.css";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxVWJccOKi8rej-aA6dFJ70LVxRMfCDgDKhdCzsk-M2Pfc4iZi_xTyOoNKuyhgWzgtO/exec";

// Array of explicit CSS classes containing differing transition configurations
const TRANSITIONS = ["slide-fade", "zoom-fade", "slide-up-fade", "pure-fade"];

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const [transitionClass, setTransitionClass] = useState(TRANSITIONS[0]);
  const canvasRef = useRef(null);

  const getDirectStreamUrl = (url, type) => {
  if (!url) return "";

  url = String(url).trim();

  // Already a data URI
  if (url.startsWith("data:")) {
    return url;
  }

  // Base64 content (no http / drive url)
  if (!url.startsWith("http")) {
    if (type === "video" || type === "reel") {
      return `data:video/mp4;base64,${url}`;
    } else {
      return `data:image/png;base64,${url}`;
    }
  }

  // Google Drive URLs
  if (url.includes("drive.google.com")) {
    const match =
      url.match(/\/d\/([^/]+)/) ||
      url.match(/[?&]id=([^&]+)/);

    if (match) {
      const id = match[1];

      if (type === "video" || type === "reel") {
        return `https://drive.google.com/file/d/${id}/preview`;
      }

      return `https://drive.google.com/thumbnail?id=${id}&sz=w2000`;
    }
  }

  return url;
};

  // ================= FETCH GALLERY =================
  useEffect(() => {
    setLoading(true);
    fetch(`${SCRIPT_URL}?type=gallery`)
      .then((res) => res.json())
      .then((data) => {
        let fetchedItems = [];
        if (Array.isArray(data)) fetchedItems = data;
        else if (data.gallery || data.Gallery) fetchedItems = data.gallery || data.Gallery;
        else if (data.data || data.Data) fetchedItems = data.data || data.Data;
        else if (data.images || data.Images) fetchedItems = data.images || data.Images;
console.log("Fetched Items:", fetchedItems);
       const processedImages = [];
const processedVideos = [];

fetchedItems.forEach((item) => {
  const rawMedia =
    typeof item === "string"
      ? item
      : item.Image ||
        item.image ||
        item.mediaUrl ||
        item.url ||
        item.URL ||
        "";

  const type =
    typeof item === "string"
      ? "image"
      : (
          item.Type ||
          item.type ||
          item.MediaType ||
          item.mediaType ||
          "image"
        )
          .toString()
          .toLowerCase()
          .trim();

  const mediaUrl = getDirectStreamUrl(rawMedia, type);

  if (!mediaUrl) return;

  if (type === "video" || type === "reel") {
    processedVideos.push({
      url: mediaUrl,
      type: "video",
      isBase64: mediaUrl.startsWith("data:")
    });
  } else {
    processedImages.push(mediaUrl);
  }
});

console.log("Images", processedImages);
console.log("Videos", processedVideos);
console.log("Processed Images:", processedImages);
processedVideos.forEach((video, i) => {
  console.log(`Video ${i + 1}:`, video.url);
});

console.log("Processed Videos:", processedVideos);
        setImages(processedImages);
        setVideos(processedVideos);
       setTimeout(() => {
  setLoading(false);
}, 500);
      })
      .catch((err) => {
        console.error("Gallery Error:", err);
        setLoading(false);
      });
  }, []);

  // ================= SLIDER TRANSITION CONTROLLER =================
  useEffect(() => {
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      // Pick a random transition class name before shifting index positions
      const randomTransition = TRANSITIONS[Math.floor(Math.random() * TRANSITIONS.length)];
      setTransitionClass(randomTransition);

      setCurrentImgIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Transitions slide every 4 seconds

    return () => clearInterval(interval);
  }, [images]);

  // ================= BUBBLE ANIMATION =================
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animationFrameId;

    const resizeCanvas = () => {
      const parent = canvas.parentElement;
      if (parent) {
        canvas.width = parent.clientWidth;
        canvas.height = parent.clientHeight;
      }
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    class Bubble {
      constructor(width, height) {
        this.x = Math.random() * width;
        this.y = height + Math.random() * 100;
        this.radius = Math.random() * 15 + 5;
        this.speed = Math.random() + 0.5;
        this.opacity = Math.random() * 0.3 + 0.1;
        this.wobble = Math.random() * 2;
        this.wobbleSpeed = Math.random() * 0.02;
      }
      update(width, height) {
        this.y -= this.speed;
        this.wobble += this.wobbleSpeed;
        this.x += Math.sin(this.wobble) * 0.5;
        if (this.y + this.radius < 0) {
          this.y = height + this.radius;
          this.x = Math.random() * width;
        }
      }
      draw(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(0,162,232,${this.opacity})`;
        ctx.fill();
      }
    }

    const bubbles = [];
    for (let i = 0; i < 40; i++) {
      const bubble = new Bubble(canvas.width, canvas.height);
      bubble.y = Math.random() * canvas.height;
      bubbles.push(bubble);
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      bubbles.forEach((bubble) => {
        bubble.update(canvas.width, canvas.height);
        bubble.draw(ctx);
      });
      animationFrameId = requestAnimationFrame(animate);
    };
    animate();

    return () => {
      window.removeEventListener("resize", resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <h1>Our Gallery</h1>
        <h2>Memories From Our Beautiful Tours</h2>
      </section>

      <section className="gallery-content">

       {loading ? (
  <div className="gallery-loader">
    <div className="gallery-spinner"></div>

    <h2>Loading Gallery...</h2>

    <p>Please wait while we fetch beautiful memories.</p>
  </div>
) : images.length === 0 && videos.length === 0 ? (
          <div className="gallery-status">
            <h3>No gallery items found.</h3>
          </div>
        ) : (
          <div className="gallery-layout-wrapper">
            
            {/* ====== IMAGE SLIDER SECTION ====== */}
            {images.length > 0 && (
              <div className="gallery-slider-container">
                <h3 className="section-title">Captured Moments</h3>
                <div className="gallery-slider">
                  {images.map((imgUrl, idx) => (
                    <img
                      key={idx}
                      src={imgUrl}
                      alt={`Tour Slide ${idx + 1}`}
                      className={`slider-img ${idx === currentImgIndex ? `active ${transitionClass}` : ""}`}
                    />
                  ))}
                  {/* Slider Progress Bar Indicator */}
                  <div className="slider-dots">
                    {images.map((_, idx) => (
                      <span 
                        key={idx} 
                        className={`dot ${idx === currentImgIndex ? "active" : ""}`}
                        onClick={() => setCurrentImgIndex(idx)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* ====== AUTOPLAY VIDEO GRID SECTION ====== */}
            {/* ====== AUTOPLAY VIDEO GRID SECTION ====== */}
{/* ====== AUTOPLAY VIDEO GRID SECTION ====== */}
{videos.map((video, index) => (
  <div className="vid-showcase-card" key={index}>
    {video.url.startsWith("data:") ? (
      <video
        className="vid-showcase-media"
        autoPlay
        muted
        loop
        controls
        playsInline
        preload="metadata"
      >
        <source src={video.url} type="video/mp4" />
      </video>
    ) : (
      <iframe
        src={`${video.url}?autoplay=1&mute=1`}
        className="vid-showcase-media"
        title={`Video ${index}`}
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
    )}
  </div>
))}

          </div>
        )}
      </section>
    </div>
  );
}